import type { FaireProductEntity } from "../../entity_types/product";

export const p_kkfm8ryqyw: FaireProductEntity = {
  token: "p_kkfm8ryqyw",
  type: "product",
  name: "Naturally Lemon Vegan Macarons | No Artificial Color",
  brandToken: "b_384hnspyq8",
  brandName: "macaron centrale",
  imageUrl:
    "https://cdn.faire.com/fastly/7b75b47cde51e69e769c6e9154013a8673c68f797337c6398c21a5d2ac02bd9e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2556962ebc7279aedbe4400e3866c742a0f4c9474550b64f1a697de32c2cbf1a.jpeg",
    "https://cdn.faire.com/fastly/a1ca30e0265cf33e95606a6722351527993f50865ae384731e852b93290f7137.jpeg",
    "https://cdn.faire.com/fastly/a7684bc4f5617fddc1d23af44e70fd06d5277ba8058007fc03bcd919e5689ff3.jpeg",
    "https://cdn.faire.com/fastly/eac9abec673de0b1ddea487e83dbde07021fe85ce448d013af56da7a4c7e02c8.jpeg",
    "https://cdn.faire.com/fastly/7c1ce1489555bf765fd3f183d4bfc9bb5dc9bd072b8651c330d29beb0f815d0f.jpeg",
  ],
  priceDollars: 2.08,
  description:
    "Bright, clean, and crafted entirely from plant-based ingredients, our Naturally Lemon Vegan Macarons are a refreshing addition to any retail assortment. Each macaron is naturally tinted with beta carotene, creating a soft yellow marbled finish without any artificial dyes or synthetic colors.\n\nInside, a smooth lemon vegan cream delivers a light, citrus-forward flavor that pairs perfectly with the crisp exterior and tender center of every shell. Handcrafted fresh to order, these vegan macarons offer reliable quality, beautiful presentation, and a customer-friendly flavor profile that appeals across all age groups.\n\nEach 24-pack arrives securely placed in a protective macaron tray, ensuring safe delivery and easy display for your store, café, or event-based retail.\n\n✨ Key Features\n• 100% vegan & dairy-free\n• Naturally colored with beta carotene\n• Filled with our smooth lemon vegan cream\n• Freshly made to order\n• Packaged in a protective 24-slot tray for display or resale\n• Ideal for gifting, cafés, bakeries, specialty markets & seasonal assortments\n\nA bright, naturally beautiful macaron that brings a clean, citrus touch to your vegan collection.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:47.371Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
